export default {
    namespaced: true,
    state: {
        accountmanagers: null
    },
    getters: {
        accountmanagers: (state) => {
            return state.accountmanagers;
        }
    },
    actions: {

    },
    mutations: {
        accountmanagers (state, accountmanagers) {
            state.accountmanagers = accountmanagers;
        }
    }
}